export enum Region {
    WestVlaanderen = 'West-Vlaanderen',
    OostVlaanderen = 'Oost-Vlaanderen',
    Antwerpen = 'Antwerpen',
    Limburg = 'Limburg',
    VlaamsBrabant = 'Vlaams-Brabant',
    Vlaanderen = 'Vlaanderen',
    Unknown = 'Unknown',
}
